import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-3 rounded-full font-medium transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#8B7E74] text-white hover:bg-[#6D6259] focus:ring-[#8B7E74]',
    secondary: 'bg-[#E8D5D5] text-[#3D3D3D] hover:bg-[#D4A5A5] focus:ring-[#E8D5D5]',
    outline: 'border-2 border-[#8B7E74] text-[#8B7E74] hover:bg-[#8B7E74] hover:text-white focus:ring-[#8B7E74]'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-204">
      {children}
    </motion.button>;
}